module.exports = __webpack_public_path__ + "static/media/iconKML.00e6818d.png";